export const getMimeTypeFa = (mType) => {
  if (!mType) {
    return null;
  }

  let faIcon = null

  switch (mType.split('/')[0]) {
    case 'image':
      faIcon = 'fa-regular fa-file-image';
      break;
    case 'audio':
      faIcon =  'fa-regular fa-file-audio';
      break;
    case 'video':
      faIcon = 'fa-regular fa-file-video';
      break;
    default:
      break;
  }
  
  if(faIcon === null){
    faIcon = 'fa-regular fa-file';
    switch (mType) {
      case 'application/pdf':
        faIcon = 'fa-regular fa-file-pdf';
        break;
      case 'text/plain':
        faIcon = 'fa-regular fa-file-lines';
        break;
      case 'text/html':
      case 'application/json':
        faIcon = 'fa-regular fa-file-code';
        break;
      case 'application/gzip':
      case 'application/zip':
        faIcon = 'fa-regular fa-file-zipper';
        break;
      default:
        break;
    }
  }

return faIcon;

};
